"use client";

import TopNavThree from "../../../components/Header/TopNav/TopNavThree";
import MenuFurniture from "../../../components/Header/Menu/MenuFurniture";
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import Benefit from "../../../components/Home1/Benefit";
import Footer from "../../../components/Footer/Footer";

const AboutUs = () => {
  document.title = "À Propos de Nous | Kissaria";

  return (
    <>
      <TopNavThree props="style-three bg-white" />
      <div id="header" className="relative w-full">
        <MenuFurniture props="" />
        <Breadcrumb heading="À Propos de Nous" subHeading="À Propos de Nous" />
      </div>
      <div className="about md:pt-20 pt-10">
        <div className="about-us-block">
          <div className="container">
            <div className="text flex items-center justify-center">
              <div className="content md:w-5/6 w-full">
                <div className="heading3 text-center">
                  Découvrez l'âme du Maroc avec Kissaria.
                </div>
                <div className="body1 text-center md:mt-7 mt-5">
                  Kissaria n'a pas besoin d'être présentée. En l'espace de
                  quelques années, nous sommes devenus une référence
                  incontournable pour tous les articles liés à la culture
                  marocaine. Que ce soit des vêtements traditionnels, des objets
                  d'artisanat, des accessoires ou des produits alimentaires,
                  notre boutique en ligne propose une sélection soigneusement
                  choisie qui met en avant la richesse et la diversité de notre
                  patrimoine. Nous nous engageons à soutenir les artisans locaux
                  tout en vous offrant des produits de qualité qui célèbrent la
                  culture marocaine.
                </div>
              </div>
            </div>

            <div className="list-img grid sm:grid-cols-3 gap-[30px] md:pt-20 pt-10">
              <div className="bg-img">
                <img
                  src="/about1.jpg"
                  width={2000}
                  height={3000}
                  alt="about1"
                  className="w-full object-cover h-full rounded-[30px]"
                />
              </div>
              <div className="bg-img">
                <img
                  src="/about2.jpg"
                  width={2000}
                  height={3000}
                  alt="about2"
                  className="w-full object-cover h-full rounded-[30px]"
                />
              </div>
              <div className="bg-img">
                <img
                  src="/about3.webp"
                  width={2000}
                  height={3000}
                  alt="about3"
                  className="w-full object-cover h-full rounded-[30px]"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Benefit props="md:pt-20 pt-10 mb-10" />
      <Footer />
    </>
  );
};

export default AboutUs;
